import axios from "axios";
import Base64 from "base-64";
import {security} from "../env/Environment"
const clientId = security.client_id;
const clientSecret = security.client_secret;
const serverTokenEndpoint = security.serverTokenEndpoint;
const refreshAccessTokens = true;
const tokenRefreshOffset = () => {
    const min = 5;
    const max = 10;
    return (Math.floor(Math.random() * (max - min)) + min) * 1000;
};

export const restoreSession = () => {
    const now = Date.now();
    const sessionData = sessionStorage.getItem("session");
    if (sessionData) {
        const data = JSON.parse(sessionData);
        if (data.expires_at && data.expires_at < now) {
            if (refreshAccessTokens) {
                return refreshAccessToken(data.expires_in, data.refresh_token);
            }
            return Promise.resolve(false);
        } else {
            if (!validate(data)) {
                console.log("invalid data");
                return Promise.resolve(false);
            } else {
                scheduleAccessTokenRefresh(data.expires_in, data.expires_at, data.refresh_token);
                return Promise.resolve(true);
            }
        }
    }
    return Promise.resolve(false);
};

export const authenticate = async (code, redirect_uri) => {
    const { verifier_code, serverTokenEndpoint } = security;
    let data = {
        redirect_uri: redirect_uri,
        code: code,
        scope: "read",
        grant_type:"authorization_code",
        code_verifier: verifier_code,
    }

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Basic " + Base64.encode(`${clientId}:${clientSecret}`),
    };

    try {
        const response = await makeRequest(serverTokenEndpoint, data, headers);
        return await postAuthenticate(response, null, null);
    } catch (error) {
        console.error("Erreur d'authentification :", error);
        return false;
    }
};

const makeRequest = async (url, request, headers = {}) => {
    try {
        const { data } = await axios.post(url, request, { headers });
        return data;
    } catch (error) {
        console.error("Erreur lors de la requête :", error);
    }
};

const scheduleAccessTokenRefresh = (expiresIn, expiresAt, refreshToken) => {
    if (refreshAccessTokens) {
        const now = Date.now();
        if (!expiresAt && expiresIn) {
            expiresAt = now + expiresIn * 1000;
        }
        const offset = tokenRefreshOffset * 1000;

        if (refreshToken && expiresAt && expiresAt > now - offset) {
            setTimeout(async () => {
                await refreshAccessToken(expiresIn, refreshToken);
            }, expiresAt - now - offset);
        }
    }
};

const refreshAccessToken = async (expiresIn, refreshToken) => {
    const data = {
        scope: "read",
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: clientId,
    };

    try {
        const response = await makeRequest(serverTokenEndpoint, data);
        console.log("[OAuth] ✅ Token rafraîchi avec succès à", new Date().toLocaleTimeString());
        return await postAuthenticate(response, expiresIn, refreshToken);
    } catch (error) {
        console.error("[OAuth] ❌ Erreur lors du rafraîchissement du token :", error);
        return false;
    }
};


const postAuthenticate = async (response, expiresIn, refreshToken) => {
    const { expires_in, refresh_token } = response || {};

    if (validate(response)) {
        expiresIn = expires_in || expiresIn;
        refreshToken = refresh_token || refreshToken;
        const expiresAt = absoluteExpirationTime(expiresIn);

        if (expiresAt) {
            response = {
                ...response,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refreshToken,
            };
        }

        scheduleAccessTokenRefresh(expiresIn, null, refreshToken);
       sessionStorage.setItem("session", JSON.stringify(response));
        return true;
    } else {
        sessionStorage.clear();
        return false;
    }
};

const absoluteExpirationTime = (expiresIn) => {
    return new Date(Date.now() + expiresIn * 1000).getTime();
};

const validate = (data) => {
    return data && data.access_token && data.expires_in;
};

export const getRemainingTimeBeforeRefresh = () => {
    const sessionData = sessionStorage.getItem("session");
    if (!sessionData) return null;

    const data = JSON.parse(sessionData);
    if (!data.expires_at) return null;

    const now = Date.now();
    const offset = tokenRefreshOffset(); // en secondes
    const refreshTime = data.expires_at - offset * 1000;

    const remainingMs = refreshTime - now;
    return remainingMs > 0 ? remainingMs : 0;
};


